import { PlayerPortalsPage } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export default {
  component: () => PlayerPortalsPage,
  mapEntryToProps: (entry: PLAYER_PORTALS_MODELS.Page) =>
    kontentAiDataMapping.player_portals_page(entry),
};
